/// EAN/GTIN da apresentação: conferência que avisa sem bloquear e gerador de EAN-13.
///
/// A conferência não recusa o cadastro porque o leitor também lê etiquetas internas e códigos de
/// fornecedor fora do padrão GS1; ela só aponta o que provavelmente foi digitado errado.

export type EanPrefix = 'BRAZIL' | 'INTERNAL';

const GTIN_LENGTHS = new Set([8, 12, 13, 14]);

/// Dígito verificador GS1 do corpo (todos os dígitos menos o último): pesos 3 e 1 alternados a
/// partir da direita.
export function gtinCheckDigit(body: string): number {
  let sum = 0;
  for (let index = 0; index < body.length; index += 1) {
    const digit = Number(body[body.length - 1 - index]);
    sum += digit * (index % 2 === 0 ? 3 : 1);
  }
  return (10 - (sum % 10)) % 10;
}

/// Aviso para um código que não parece EAN; `undefined` quando está vazio ou confere.
export function eanWarning(value: string | null | undefined): string | undefined {
  const code = value?.trim() ?? '';
  if (!code) return undefined;
  if (!/^\d+$/u.test(code) || !GTIN_LENGTHS.has(code.length))
    return 'Não parece um EAN: ele tem 8, 12, 13 ou 14 números. Dá para salvar assim mesmo.';
  const expected = gtinCheckDigit(code.slice(0, -1));
  if (Number(code.at(-1)) !== expected)
    return `O último número de um EAN assim seria ${expected}; confira a digitação. Dá para salvar assim mesmo.`;
  return undefined;
}

/// EAN-13 sorteado com o dígito verificador certo. `BRAZIL` começa com 789, a faixa da GS1
/// Brasil, mas o número não é registrado; `INTERNAL` começa com 2, faixa de circulação interna.
export function generateEan13(prefix: EanPrefix, random: () => number = secureDigit): string {
  const body = prefix === 'BRAZIL' ? '789' : '2';
  let digits = body;
  while (digits.length < 12) digits += String(random());
  return digits + String(gtinCheckDigit(digits));
}

function secureDigit(): number {
  const values = new Uint32Array(1);
  crypto.getRandomValues(values);
  return values[0]! % 10;
}
